import { render } from "./EditExternalClinicService.vue?vue&type=template&id=2b422e7c&scoped=true"
import script from "./EditExternalClinicService.vue?vue&type=script&lang=js"
export * from "./EditExternalClinicService.vue?vue&type=script&lang=js"

import "./EditExternalClinicService.vue?vue&type=style&index=0&id=2b422e7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b422e7c"]])

export default __exports__